import React from "react";
var __jsx = React.createElement;
import ArrowType2SVG from "../../../SVGObjects/UiKit/ArrowType2SVG";
import stl from "./MobileHeader1.module.css";
var MobileHeader1 = function MobileHeader1(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.container, " ").concat(props.className ? props.className : ""),
    style: {
      backgroundColor: props.backgroundColor
    }
  }, /*#__PURE__*/React.createElement("strong", {
    style: {
      color: props.color
    }
  }, props.title), !props.NoBack && /*#__PURE__*/React.createElement("span", {
    className: stl.fixDir
  }, /*#__PURE__*/React.createElement(ArrowType2SVG, {
    filledColor: props.color,
    onClick: function onClick() {
      return props.buttonFunction();
    }
  }))));
};
export default MobileHeader1;